const ngProducts = {
    // Products In Portal
    products: {
        product1: 'PMS',
        product2: 'AGO',
        product3: 'DPK',
        product4: 'LPG',
        total: 'TOTAL'
    }, 
    productsLower: {
        product1: 'pms',
        product2: 'ago',
        product3: 'dpk',
        product4: 'lpg'
    },    
    currency: '₦GN'
}

const frProducts = {
    // Products In Portal
    products: {
        product1: 'AUS',
        product2: 'KJD',
        product3: 'WIA',
        product4: 'CKH',
    }, 
    productsLower: {
        product1: 'aus',
        product2: 'kjd',
        product3: 'wia',
        product4: 'ckh'
    },    
    currency: '***'
}

const ghProducts = {
    // Products In Portal
    products: {
        product1: 'SGJ',
        product2: 'IWI',
        product3: 'JFJ',
        product4: 'XKD',
    }, 
    productsLower: {
        product1: 'sgj',
        product2: 'iwi',
        product3: 'jfj',
        product4: 'xkd'
    },    
    currency: '***'
}

const usProducts = {
    // Products In Portal
    products: {
        product1: 'AAA',
        product2: 'BBB',
        product3: 'CCC',
        product4: 'DDD',
    }, 
    productsLower: {
        product1: 'aaa',
        product2: 'bbb',
        product3: 'ccc',
        product4: 'ddd'
    },    
    currency: '***'
}

const jpProducts = {
    // Products In Portal
    products: {
        product1: 'YYY',
        product2: 'EEE',
        product3: 'QQQ',
        product4: 'NNN',
    }, 
    productsLower: {
        product1: 'yyy',
        product2: 'eee',
        product3: 'qqq',
        product4: 'nnn'
    },    
    currency: '***'
}

const allProducts = {
    NG: ngProducts,
    FR: frProducts,
    GH: ghProducts,
    US: usProducts,
    JP: jpProducts,
    KE: jpProducts
}

export default allProducts